import * as genericUtils from '@tolk-ai/generic-utils';
import * as browserUtils from '@tolk-ai/browser-utils';

var CreateOneCustomerApiInfoErrors;

(function (CreateOneCustomerApiInfoErrors) {
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["emptyUrl"] = 0] = "emptyUrl";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["invalidUrlFormat"] = 1] = "invalidUrlFormat";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["emptyName"] = 2] = "emptyName";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["inputsInvalid"] = 3] = "inputsInvalid";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["headersInvalid"] = 4] = "headersInvalid";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["outputsInvalid"] = 5] = "outputsInvalid";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["bodyInvalid"] = 6] = "bodyInvalid";
  CreateOneCustomerApiInfoErrors[CreateOneCustomerApiInfoErrors["inexistingBot"] = 7] = "inexistingBot";
})(CreateOneCustomerApiInfoErrors || (CreateOneCustomerApiInfoErrors = {}));

var GetManyCustomerApiErrors;

(function (GetManyCustomerApiErrors) {
  GetManyCustomerApiErrors[GetManyCustomerApiErrors["inexistingBot"] = 0] = "inexistingBot";
})(GetManyCustomerApiErrors || (GetManyCustomerApiErrors = {}));

var GetOneCustomerApiInfoErrors;

(function (GetOneCustomerApiInfoErrors) {
  GetOneCustomerApiInfoErrors[GetOneCustomerApiInfoErrors["inexistingCustomerApiInfo"] = 0] = "inexistingCustomerApiInfo";
})(GetOneCustomerApiInfoErrors || (GetOneCustomerApiInfoErrors = {}));

var UpdateOneCustomerApiInfoErrors;

(function (UpdateOneCustomerApiInfoErrors) {
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["emptyUrl"] = 0] = "emptyUrl";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["invalidUrlFormat"] = 1] = "invalidUrlFormat";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["emptyName"] = 2] = "emptyName";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["inputsInvalid"] = 3] = "inputsInvalid";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["headersInvalid"] = 4] = "headersInvalid";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["outputsInvalid"] = 5] = "outputsInvalid";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["bodyInvalid"] = 6] = "bodyInvalid";
  UpdateOneCustomerApiInfoErrors[UpdateOneCustomerApiInfoErrors["inexistingCustomerApi"] = 7] = "inexistingCustomerApi";
})(UpdateOneCustomerApiInfoErrors || (UpdateOneCustomerApiInfoErrors = {}));

var TestCustomerApiErrors;

(function (TestCustomerApiErrors) {
  TestCustomerApiErrors[TestCustomerApiErrors["inexistingCustomerApi"] = 0] = "inexistingCustomerApi";
})(TestCustomerApiErrors || (TestCustomerApiErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get CreateOneCustomerApiInfoErrors () { return CreateOneCustomerApiInfoErrors; },
  get GetManyCustomerApiErrors () { return GetManyCustomerApiErrors; },
  get GetOneCustomerApiInfoErrors () { return GetOneCustomerApiInfoErrors; },
  get TestCustomerApiErrors () { return TestCustomerApiErrors; },
  get UpdateOneCustomerApiInfoErrors () { return UpdateOneCustomerApiInfoErrors; }
});

const getRestManyCustomerApi = authenticatedRequest => async botId => {
  try {
    return await authenticatedRequest('get', `/v1/bots/${botId}/customers-api`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingBot':
          return GetManyCustomerApiErrors.inexistingBot;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getRestCustomerApiInfo = authenticatedRequest => async (botId, customerApiId) => {
  try {
    return await authenticatedRequest('get', `/v1/bots/${botId}/customers-api/${customerApiId}`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingCustomerApiInfo':
          return GetOneCustomerApiInfoErrors.inexistingCustomerApiInfo;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const createOneCustomerApiInfo$2 = authenticatedRequest => async (botId, customerApiData) => {
  try {
    return await authenticatedRequest('post', `/v1/bots/${botId}/customers-api`, customerApiData);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'emptyUrl':
          return CreateOneCustomerApiInfoErrors.emptyUrl;

        case 'invalidUrlFormat':
          return CreateOneCustomerApiInfoErrors.invalidUrlFormat;

        case 'emptyName':
          return CreateOneCustomerApiInfoErrors.emptyName;

        case 'inputsInvalid':
          return CreateOneCustomerApiInfoErrors.inputsInvalid;

        case 'headersInvalid':
          return CreateOneCustomerApiInfoErrors.headersInvalid;

        case 'outputsInvalid':
          return CreateOneCustomerApiInfoErrors.outputsInvalid;

        case 'bodyInvalid':
          return CreateOneCustomerApiInfoErrors.bodyInvalid;

        case 'inexistingBot':
          return CreateOneCustomerApiInfoErrors.inexistingBot;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const updateOneCustomerApiInfo$2 = authenticatedRequest => async (botId, customerApiId, customerApiData) => {
  try {
    await authenticatedRequest('put', `/v1/bots/${botId}/customers-api/${customerApiId}`, customerApiData);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingCustomerApi':
          return UpdateOneCustomerApiInfoErrors.inexistingCustomerApi;

        case 'emptyUrl':
          return UpdateOneCustomerApiInfoErrors.emptyUrl;

        case 'invalidUrlFormat':
          return UpdateOneCustomerApiInfoErrors.invalidUrlFormat;

        case 'emptyName':
          return UpdateOneCustomerApiInfoErrors.emptyName;

        case 'inputsInvalid':
          return UpdateOneCustomerApiInfoErrors.inputsInvalid;

        case 'headersInvalid':
          return UpdateOneCustomerApiInfoErrors.headersInvalid;

        case 'outputsInvalid':
          return UpdateOneCustomerApiInfoErrors.outputsInvalid;

        case 'bodyInvalid':
          return UpdateOneCustomerApiInfoErrors.bodyInvalid;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const testCustomerApi$2 = authenticatedRequest => async (botId, customerApiId) => {
  try {
    return await authenticatedRequest('get', `/v1/bots/${botId}/customers-api/${customerApiId}/test`);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingCustomerApi':
          return TestCustomerApiErrors.inexistingCustomerApi;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertManyRestCustomerApiToCustomerApi = manyRestCustomerApi => manyRestCustomerApi.map(restCustomerApi => ({
  botId: restCustomerApi.botId,
  id: restCustomerApi.id,
  method: restCustomerApi.method,
  name: restCustomerApi.name,
  url: restCustomerApi.url
}));

const convertRestCustomerApiGetToCustomerApiDataGet = restCustomerApiGet => ({
  headers: restCustomerApiGet.headers,
  inputs: restCustomerApiGet.inputs,
  method: restCustomerApiGet.method,
  name: restCustomerApiGet.name,
  outputs: restCustomerApiGet.outputs,
  url: restCustomerApiGet.url
});

const convertRestCustomerApiPostToCustomerApiDataPost = restCustomerApiPost => ({
  body: restCustomerApiPost.body,
  headers: restCustomerApiPost.headers,
  inputs: restCustomerApiPost.inputs,
  method: restCustomerApiPost.method,
  name: restCustomerApiPost.name,
  outputs: restCustomerApiPost.outputs,
  url: restCustomerApiPost.url
});

const convertRestCustomerApiDataToCustomerApiData = restCustomerApiData => {
  switch (restCustomerApiData.method) {
    case 'GET':
      return convertRestCustomerApiGetToCustomerApiDataGet(restCustomerApiData);

    default:
      return convertRestCustomerApiPostToCustomerApiDataPost(restCustomerApiData);
  }
};

const convertRestCustomerApiInfoToCustomerApiInfo = restCustomerApiInfo => ({
  botId: restCustomerApiInfo.botId,
  details: convertRestCustomerApiDataToCustomerApiData(restCustomerApiInfo.details),
  id: restCustomerApiInfo.id
});

const convertRestCustomerApiResponseSuccessToCustomerApiResponseSuccess = restCustomerApiresponseSuccess => ({
  data: restCustomerApiresponseSuccess.data
});

const convertRestCustomerApiResponseErrorToCustomerApiResponseError = restCustomerApiresponseError => ({
  error: restCustomerApiresponseError.error
});

const convertRestCustomerApiResponseToCustomerApiResponse = restCustomerApiResponse => {
  return {
    response: 'data' in restCustomerApiResponse.response ? convertRestCustomerApiResponseSuccessToCustomerApiResponseSuccess(restCustomerApiResponse.response) : convertRestCustomerApiResponseErrorToCustomerApiResponseError(restCustomerApiResponse.response)
  };
};

const getManyCustomerApi$1 = authenticatedRequest => async botId => {
  const result = await getRestManyCustomerApi(authenticatedRequest)(botId);

  if (genericUtils.isDomainError(result, GetManyCustomerApiErrors)) {
    return result;
  }

  return convertManyRestCustomerApiToCustomerApi(result);
};

const getOneCustomerApiInfo$1 = authenticatedRequest => async (botId, customerApiId) => {
  const restCustomerApiInfo = await getRestCustomerApiInfo(authenticatedRequest)(botId, customerApiId);

  if (genericUtils.isDomainError(restCustomerApiInfo, GetOneCustomerApiInfoErrors)) {
    return restCustomerApiInfo;
  }

  return convertRestCustomerApiInfoToCustomerApiInfo(restCustomerApiInfo);
};

const createOneCustomerApiInfo$1 = authenticatedRequest => async (botId, customerApiData) => {
  const result = await createOneCustomerApiInfo$2(authenticatedRequest)(botId, customerApiData);

  if (genericUtils.isDomainError(result, CreateOneCustomerApiInfoErrors)) {
    return result;
  }

  return result;
};

const updateOneCustomerApiInfo$1 = authenticatedRequest => async (botId, customerApiId, customerApiData) => {
  const result = await updateOneCustomerApiInfo$2(authenticatedRequest)(botId, customerApiId, customerApiData);

  if (genericUtils.isDomainError(result, UpdateOneCustomerApiInfoErrors)) {
    return result;
  }
};

const testCustomerApi$1 = authenticatedRequest => async (botId, customerApiId) => {
  const result = await testCustomerApi$2(authenticatedRequest)(botId, customerApiId);

  if (genericUtils.isDomainError(result, TestCustomerApiErrors)) {
    return result;
  }

  return convertRestCustomerApiResponseToCustomerApiResponse(result);
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOneCustomerApiInfo: createOneCustomerApiInfo$1,
  getManyCustomerApi: getManyCustomerApi$1,
  getOneCustomerApiInfo: getOneCustomerApiInfo$1,
  testCustomerApi: testCustomerApi$1,
  updateOneCustomerApiInfo: updateOneCustomerApiInfo$1
});

const getOneMongoBotByBotId = mongodb => async botId => mongodb.collection('api_bots').findOne({
  bot_id: botId
});

const convertMongodbBotToBot = mongodbBot => ({
  id: mongodbBot.bot_id
});

const getOneBotByBotId = mongodb => async botId => {
  const result = await getOneMongoBotByBotId(mongodb)(botId);

  if (result === null) {
    return null;
  }

  return convertMongodbBotToBot(result);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneBotByBotId: getOneBotByBotId
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const convertManyHeaderToHeadersAxios = headers => {
  return headers.reduce((accumulator, current) => {
    return Object.assign(Object.assign({}, accumulator), {
      [current.name]: current.value
    });
  }, {});
};

const convertManyInputToParamatersAxios = inputs => {
  return inputs.reduce((accumulator, current) => {
    return Object.assign(Object.assign({}, accumulator), {
      [current.name]: current.value
    });
  }, {});
};

const replaceCurlyWithInputsValue = (textBody, match, inputs) => {
  if (genericUtils.isEmpty(match)) {
    return textBody;
  }

  const inputName = match.replace(/\{/g, '').replace(/\}/g, '');
  const inputFind = inputs.find(input => input.name === inputName);

  if (typeof inputFind === 'undefined') {
    return textBody;
  }

  return textBody.replace(match, inputFind.value);
};

const buildCustomerApiBodyToDataAxios = (customerApiBody, inputs) => {
  const curlyBracketRegex = /\{\{(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?\}\}/g;
  const curlyMatchs = curlyBracketRegex.exec(customerApiBody);

  if (curlyMatchs === null) {
    return JSON.parse(customerApiBody);
  }

  const newBody = curlyMatchs.reduce((previous, current) => {
    return replaceCurlyWithInputsValue(previous, current, inputs);
  }, customerApiBody);
  return JSON.parse(newBody);
};

const headerHasAuthorisation = headers => 'Authorization' in headers;

const formatAxiosResquestConfig = customerApiData => {
  const headers = convertManyHeaderToHeadersAxios(customerApiData.headers);
  const axiosRequestConfigBase = {
    headers,
    maxBodyLength: 2000,
    maxContentLength: 2000,
    method: customerApiData.method,
    responseType: 'json',
    url: customerApiData.url,

    validateStatus(status) {
      return status >= genericUtils.HTTP_CODE.OK && status <= genericUtils.HTTP_CODE.NO_CONTENT;
    },

    withCredentials: headerHasAuthorisation(headers)
  };
  const parameters = convertManyInputToParamatersAxios(customerApiData.inputs);

  switch (customerApiData.method) {
    case 'POST':
      {
        const data = buildCustomerApiBodyToDataAxios(customerApiData.body, customerApiData.inputs);
        return Object.assign(Object.assign({}, axiosRequestConfigBase), {
          data
        });
      }

    default:
      {
        return Object.assign(Object.assign({}, axiosRequestConfigBase), {
          params: parameters
        });
      }
  }
};

const executeCustomerApi$1 = axios => async customerApiData => {
  const axiosRequestConfig = formatAxiosResquestConfig(customerApiData);

  try {
    return await axios.request(axiosRequestConfig);
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      return {
        error: error.response.data.error
      };
    }

    if (browserUtils.isAxiosError(error)) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _restError = __rest(error, ["stack"]);

      return {
        error: _restError.toJSON()
      };
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars


    const _a = genericUtils.sanitizeError(error),
          restError = __rest(_a, ["stack"]);

    return {
      error: restError
    };
  }
};

const executeCustomerApi = axios => async customerApiData => {
  const result = await executeCustomerApi$1(axios)(customerApiData);

  if ('data' in result) {
    return {
      response: {
        data: result.data
      }
    };
  }

  return {
    response: {
      error: result.error
    }
  };
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  executeCustomerApi: executeCustomerApi
});

const getManyPgCustomerApiByBotId = pool => async botId => {
  try {
    const result = await pool.query(`SELECT
          customer_api_id,
          bot_id,
          method,
          name,
          url,
          body
        FROM customer_api
        WHERE bot_id = $1
        ORDER BY id ASC;`, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgCustomerApibyBotIdAndCustomerApiId = pool => async (botId, customerApiId) => {
  var _a;

  try {
    const result = await pool.query(`SELECT
          customer_api_id,
          bot_id,
          method,
          name,
          url,
          body
        FROM customer_api
        WHERE bot_id = $1 AND customer_api_id = $2 ;`, [botId, customerApiId]);
    return (_a = result.rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgCustomerApiDataByCustomerApiId = pool => async customerApiId => {
  try {
    const result = await pool.query(`SELECT
          name,
          "format",
          value,
          "type"
        FROM customer_api_data
        WHERE customer_api_id = (SELECT id FROM customer_api WHERE customer_api_id = $1);`, [customerApiId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const insertOnePgCustomerApi = pool => async pgCustomerApi => {
  try {
    await pool.query(`INSERT INTO customer_api(
            customer_api_id,
            bot_id,
            method,
            name,
            url,
            body
            )
            VALUES($1, $2, $3, $4, $5, $6)`, [pgCustomerApi.customer_api_id, pgCustomerApi.bot_id, pgCustomerApi.method, pgCustomerApi.name, pgCustomerApi.url, pgCustomerApi.body]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const insertOnePgCustomerApiData = pool => async (customerApiId, pgCustomerApiData) => {
  try {
    await pool.query(`INSERT INTO customer_api_data(
          customer_api_id,
          name,
          "format",
          value,
          "type"
        )
        VALUES(
          (SELECT id FROM customer_api WHERE customer_api_id = $1),
           $2, $3, $4, $5)`, [customerApiId, pgCustomerApiData.name, pgCustomerApiData.format, pgCustomerApiData.value, pgCustomerApiData.type]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateOnePgCustomerApi = pool => async (customerApiId, pgCustomerApi) => {
  try {
    await pool.query(`UPDATE "customer_api"
        SET method=$2, name= $3, url = $4, body = $5
        WHERE customer_api_id=$1;
        `, [customerApiId, pgCustomerApi.method, pgCustomerApi.name, pgCustomerApi.url, pgCustomerApi.body]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteManyPgCustomerApiData = pool => async customerApiId => {
  try {
    await pool.query(`DELETE FROM "customer_api_data"
            WHERE customer_api_id = (SELECT id FROM customer_api WHERE customer_api_id = $1);
             `, [customerApiId]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertManyPgCustomerApiToCustomerApi = manyPgCustomerApi => manyPgCustomerApi.map(pgCustomerApi => ({
  botId: pgCustomerApi.bot_id,
  id: pgCustomerApi.customer_api_id,
  method: pgCustomerApi.method,
  name: pgCustomerApi.name,
  url: pgCustomerApi.url
}));

const convertPgCustomerApiPostAndPgCustomerApiDataToCustomerApiDataPost = (pgCustomerApiPost, manyPgCustomerApiData) => ({
  body: pgCustomerApiPost.body,
  headers: manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'header').map(pgCustomerApiDataHeader => ({
    name: pgCustomerApiDataHeader.name,
    value: pgCustomerApiDataHeader.value
  })),
  inputs: manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'input').map(pgCustomerApiDataInput => ({
    name: pgCustomerApiDataInput.name,
    type: pgCustomerApiDataInput.format,
    value: pgCustomerApiDataInput.value
  })),
  method: pgCustomerApiPost.method,
  name: pgCustomerApiPost.name,
  outputs: manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'output').map(pgCustomerApiDataOutput => ({
    name: pgCustomerApiDataOutput.name,
    type: pgCustomerApiDataOutput.format,
    value: pgCustomerApiDataOutput.value
  })),
  url: pgCustomerApiPost.url
});

const convertPgCustomerApiGetAndPgCustomerApiDataToCustomerApiDataGet = (pgCustomerApiGet, manyPgCustomerApiData) => ({
  headers: manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'header').map(pgCustomerApiDataHeader => ({
    name: pgCustomerApiDataHeader.name,
    value: pgCustomerApiDataHeader.value
  })),
  inputs: manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'input').map(pgCustomerApiDataInput => ({
    name: pgCustomerApiDataInput.name,
    type: pgCustomerApiDataInput.format,
    value: pgCustomerApiDataInput.value
  })),
  method: pgCustomerApiGet.method,
  name: pgCustomerApiGet.name,
  outputs: manyPgCustomerApiData.filter(pgCustomerApiData => pgCustomerApiData.type === 'output').map(pgCustomerApiDataOutput => ({
    name: pgCustomerApiDataOutput.name,
    type: pgCustomerApiDataOutput.format,
    value: pgCustomerApiDataOutput.value
  })),
  url: pgCustomerApiGet.url
});

const convertPgCustomerApiAndPgCustomerApiDataToCustomerApiInfo = (pgCustomerApi, manyPgCustomerApiData) => {
  switch (pgCustomerApi.method) {
    case 'GET':
      return {
        botId: pgCustomerApi.bot_id,
        details: convertPgCustomerApiGetAndPgCustomerApiDataToCustomerApiDataGet(pgCustomerApi, manyPgCustomerApiData),
        id: pgCustomerApi.customer_api_id
      };

    default:
      return {
        botId: pgCustomerApi.bot_id,
        details: convertPgCustomerApiPostAndPgCustomerApiDataToCustomerApiDataPost(pgCustomerApi, manyPgCustomerApiData),
        id: pgCustomerApi.customer_api_id
      };
  }
};

const convertInputsToPgCustomerApiData = inputs => inputs.map(input => ({
  format: input.type,
  name: input.name,
  type: 'input',
  value: input.value
}));

const convertHeadersToPgCustomerApiData = headers => headers.map(header => ({
  format: 'string',
  name: header.name,
  type: 'header',
  value: header.value
}));

const convertOutputsToPgCustomerApiData = outputs => outputs.map(output => ({
  format: output.type,
  name: output.name,
  type: 'output',
  value: output.value
}));

const factoryPgCustomerApiPost = (botId, customerApiId, customerApiDataPost) => ({
  body: customerApiDataPost.body,
  bot_id: botId,
  customer_api_id: customerApiId,
  method: customerApiDataPost.method,
  name: customerApiDataPost.name,
  url: customerApiDataPost.url
});

const factoryPgCustomerApiGet = (botId, customerApiId, customerApiDataGet) => ({
  body: null,
  bot_id: botId,
  customer_api_id: customerApiId,
  method: customerApiDataGet.method,
  name: customerApiDataGet.name,
  url: customerApiDataGet.url
});

const factoryPgCustomerApi = (botId, customerApiId, customerApiData) => {
  switch (customerApiData.method) {
    case 'GET':
      return factoryPgCustomerApiGet(botId, customerApiId, customerApiData);

    default:
      return factoryPgCustomerApiPost(botId, customerApiId, customerApiData);
  }
};

const getManyCustomerApiByBotId = pool => async botId => {
  const manyPgCustomerApi = await getManyPgCustomerApiByBotId(pool)(botId);
  return convertManyPgCustomerApiToCustomerApi(manyPgCustomerApi);
};

const getOneCustomerApiInfoByIdAndBotId = pool => async (botId, customerApiId) => {
  const pgCustomerApi = await getOnePgCustomerApibyBotIdAndCustomerApiId(pool)(botId, customerApiId);

  if (pgCustomerApi === null) {
    return null;
  }

  const pgCustomerApiData = await getManyPgCustomerApiDataByCustomerApiId(pool)(customerApiId);
  return convertPgCustomerApiAndPgCustomerApiDataToCustomerApiInfo(pgCustomerApi, pgCustomerApiData);
};

const saveOneCustomerApi = pool => async customerApiInfo => {
  const pgCustomerApi = factoryPgCustomerApi(customerApiInfo.botId, customerApiInfo.id, customerApiInfo.details);
  await insertOnePgCustomerApi(pool)(pgCustomerApi);
  const manyPgCustomerApiData = [...convertInputsToPgCustomerApiData(customerApiInfo.details.inputs), ...convertHeadersToPgCustomerApiData(customerApiInfo.details.headers), ...convertOutputsToPgCustomerApiData(customerApiInfo.details.outputs)];
  await Promise.all(manyPgCustomerApiData.map(async pgCustomerApiData => insertOnePgCustomerApiData(pool)(customerApiInfo.id, pgCustomerApiData)));
};

const updateOneCustomerApi = pool => async (botId, customerApiId, customerApiData) => {
  const pgCustomerApi = factoryPgCustomerApi(botId, customerApiId, customerApiData);
  await updateOnePgCustomerApi(pool)(customerApiId, pgCustomerApi);
  const manyPgCustomerApiData = [...convertInputsToPgCustomerApiData(customerApiData.inputs), ...convertHeadersToPgCustomerApiData(customerApiData.headers), ...convertOutputsToPgCustomerApiData(customerApiData.outputs)];
  await deleteManyPgCustomerApiData(pool)(customerApiId);
  await Promise.all(manyPgCustomerApiData.map(async pgCustomerApiData => insertOnePgCustomerApiData(pool)(customerApiId, pgCustomerApiData)));
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManyCustomerApiByBotId: getManyCustomerApiByBotId,
  getOneCustomerApiInfoByIdAndBotId: getOneCustomerApiInfoByIdAndBotId,
  saveOneCustomerApi: saveOneCustomerApi,
  updateOneCustomerApi: updateOneCustomerApi
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestParameterBotId: {
		type: "object",
		properties: {
			botId: {
				type: "string"
			}
		},
		required: [
			"botId"
		],
		additionalProperties: false
	},
	RestCustomerApiId: {
		type: "string"
	},
	RestCustomerApiMethod: {
		type: "string",
		"enum": [
			"GET",
			"POST"
		]
	},
	RestCustomerApiInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	RestCustomerApiHearder: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"value"
		],
		additionalProperties: false
	},
	RestCustomerApiOutput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number",
					"boolean"
				]
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	RestCustomerApiDataBase: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInput"
				}
			},
			url: {
				type: "string"
			},
			headers: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiHearder"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiOutput"
				}
			}
		},
		required: [
			"name",
			"inputs",
			"url",
			"headers",
			"outputs"
		],
		additionalProperties: false
	},
	RestCustomerApiDataPost: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "POST"
			},
			body: {
				type: "string"
			},
			name: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInput"
				}
			},
			url: {
				type: "string"
			},
			headers: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiHearder"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiOutput"
				}
			}
		},
		required: [
			"body",
			"headers",
			"inputs",
			"method",
			"name",
			"outputs",
			"url"
		]
	},
	RestCustomerApiDataGet: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "GET"
			},
			name: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiInput"
				}
			},
			url: {
				type: "string"
			},
			headers: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiHearder"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/RestCustomerApiOutput"
				}
			}
		},
		required: [
			"headers",
			"inputs",
			"method",
			"name",
			"outputs",
			"url"
		]
	},
	RestCustomerApiData: {
		anyOf: [
			{
				$ref: "#/definitions/RestCustomerApiDataPost"
			},
			{
				$ref: "#/definitions/RestCustomerApiDataGet"
			}
		]
	},
	RestCustomerApiInfo: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/RestCustomerApiId"
			},
			details: {
				$ref: "#/definitions/RestCustomerApiData"
			},
			botId: {
				type: "string"
			}
		},
		required: [
			"id",
			"details",
			"botId"
		],
		additionalProperties: false
	},
	RestCustomerApi: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/RestCustomerApiId"
			},
			botId: {
				type: "string"
			},
			method: {
				$ref: "#/definitions/RestCustomerApiMethod"
			},
			name: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"id",
			"botId",
			"method",
			"name",
			"url"
		],
		additionalProperties: false
	},
	RestManyCustomerApi: {
		type: "array",
		items: {
			$ref: "#/definitions/RestCustomerApi"
		}
	},
	RestCustomerApiResponseSuccess: {
		type: "object",
		properties: {
			data: {
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	RestCustomerApiResponseError: {
		type: "object",
		properties: {
			error: {
			}
		},
		required: [
			"error"
		],
		additionalProperties: false
	},
	RestCustomerApiResponse: {
		type: "object",
		properties: {
			response: {
				anyOf: [
					{
						$ref: "#/definitions/RestCustomerApiResponseSuccess"
					},
					{
						$ref: "#/definitions/RestCustomerApiResponseError"
					}
				]
			}
		},
		required: [
			"response"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	CustomerApiId: {
		type: "string"
	},
	CustomerApiMethod: {
		type: "string",
		"enum": [
			"GET",
			"POST"
		]
	},
	Input: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	Output: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			type: {
				type: "string",
				"enum": [
					"string",
					"number",
					"boolean"
				]
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"type",
			"value"
		],
		additionalProperties: false
	},
	Header: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"value"
		],
		additionalProperties: false
	},
	CustomerApiDataBase: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/Input"
				}
			},
			url: {
				type: "string"
			},
			headers: {
				type: "array",
				items: {
					$ref: "#/definitions/Header"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/Output"
				}
			}
		},
		required: [
			"name",
			"inputs",
			"url",
			"headers",
			"outputs"
		],
		additionalProperties: false
	},
	CustomerApiDataPost: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "POST"
			},
			body: {
				type: "string"
			},
			name: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/Input"
				}
			},
			url: {
				type: "string"
			},
			headers: {
				type: "array",
				items: {
					$ref: "#/definitions/Header"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/Output"
				}
			}
		},
		required: [
			"body",
			"headers",
			"inputs",
			"method",
			"name",
			"outputs",
			"url"
		]
	},
	CustomerApiDataGet: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "GET"
			},
			name: {
				type: "string"
			},
			inputs: {
				type: "array",
				items: {
					$ref: "#/definitions/Input"
				}
			},
			url: {
				type: "string"
			},
			headers: {
				type: "array",
				items: {
					$ref: "#/definitions/Header"
				}
			},
			outputs: {
				type: "array",
				items: {
					$ref: "#/definitions/Output"
				}
			}
		},
		required: [
			"headers",
			"inputs",
			"method",
			"name",
			"outputs",
			"url"
		]
	},
	CustomerApiData: {
		anyOf: [
			{
				$ref: "#/definitions/CustomerApiDataGet"
			},
			{
				$ref: "#/definitions/CustomerApiDataPost"
			}
		]
	},
	CustomerApi: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/CustomerApiId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			name: {
				type: "string"
			},
			method: {
				$ref: "#/definitions/CustomerApiMethod"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"id",
			"botId",
			"name",
			"method",
			"url"
		],
		additionalProperties: false
	},
	CustomerApiInfo: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/CustomerApiId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			details: {
				$ref: "#/definitions/CustomerApiData"
			}
		},
		required: [
			"id",
			"botId",
			"details"
		],
		additionalProperties: false
	},
	CustomerApiResponseSuccess: {
		type: "object",
		properties: {
			data: {
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	CustomerApiResponseError: {
		type: "object",
		properties: {
			error: {
			}
		},
		required: [
			"error"
		],
		additionalProperties: false
	},
	CustomerApiResponse: {
		type: "object",
		properties: {
			response: {
				anyOf: [
					{
						$ref: "#/definitions/CustomerApiResponseSuccess"
					},
					{
						$ref: "#/definitions/CustomerApiResponseError"
					}
				]
			}
		},
		required: [
			"response"
		],
		additionalProperties: false
	},
	MongoBot: {
		type: "object",
		properties: {
			bot_id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"bot_id"
		],
		additionalProperties: false
	},
	AxiosResponseError: {
		type: "object",
		properties: {
			error: {
			}
		},
		required: [
			"error"
		],
		additionalProperties: false
	},
	PgCustomerApiInfo: {
		type: "object",
		properties: {
			customer_api_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"customer_api_id",
			"bot_id",
			"name",
			"url"
		],
		additionalProperties: false
	},
	PgCustomerApiGet: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "GET"
			},
			body: {
				type: "null"
			},
			customer_api_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"body",
			"bot_id",
			"customer_api_id",
			"method",
			"name",
			"url"
		]
	},
	PgCustomerApiPost: {
		type: "object",
		additionalProperties: false,
		properties: {
			method: {
				type: "string",
				"const": "POST"
			},
			body: {
				type: "string"
			},
			customer_api_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"body",
			"bot_id",
			"customer_api_id",
			"method",
			"name",
			"url"
		]
	},
	PgCustomerApi: {
		anyOf: [
			{
				$ref: "#/definitions/PgCustomerApiPost"
			},
			{
				$ref: "#/definitions/PgCustomerApiGet"
			}
		]
	},
	PgCustomerApiDataInput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			format: {
				type: "string",
				"enum": [
					"string",
					"number"
				]
			},
			type: {
				type: "string",
				"const": "input"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"format",
			"type",
			"value"
		],
		additionalProperties: false
	},
	PgCustomerApiDataHeader: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			format: {
				type: "string",
				"const": "string"
			},
			type: {
				type: "string",
				"const": "header"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"format",
			"type",
			"value"
		],
		additionalProperties: false
	},
	PgCustomerApiDataOutput: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			format: {
				type: "string",
				"enum": [
					"string",
					"number",
					"boolean"
				]
			},
			type: {
				type: "string",
				"const": "output"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"name",
			"format",
			"type",
			"value"
		],
		additionalProperties: false
	},
	PgCustomerApiData: {
		anyOf: [
			{
				$ref: "#/definitions/PgCustomerApiDataInput"
			},
			{
				$ref: "#/definitions/PgCustomerApiDataHeader"
			},
			{
				$ref: "#/definitions/PgCustomerApiDataOutput"
			}
		]
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const customerApiInfoFactory = () => (botId, customerApiData) => ({
  botId,
  details: customerApiData,
  id: genericUtils.generateUniqueId()
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  customerApiInfoFactory: customerApiInfoFactory
});

var ValidationInputCustomerApiErrors;

(function (ValidationInputCustomerApiErrors) {
  ValidationInputCustomerApiErrors[ValidationInputCustomerApiErrors["emptyName"] = 0] = "emptyName";
  ValidationInputCustomerApiErrors[ValidationInputCustomerApiErrors["emptyValue"] = 1] = "emptyValue";
})(ValidationInputCustomerApiErrors || (ValidationInputCustomerApiErrors = {}));

var ValidationHeaderCustomerApiErrors;

(function (ValidationHeaderCustomerApiErrors) {
  ValidationHeaderCustomerApiErrors[ValidationHeaderCustomerApiErrors["emptyName"] = 0] = "emptyName";
  ValidationHeaderCustomerApiErrors[ValidationHeaderCustomerApiErrors["emptyValue"] = 1] = "emptyValue";
})(ValidationHeaderCustomerApiErrors || (ValidationHeaderCustomerApiErrors = {}));

var ValidationOutputCustomerApiErrors;

(function (ValidationOutputCustomerApiErrors) {
  ValidationOutputCustomerApiErrors[ValidationOutputCustomerApiErrors["emptyName"] = 0] = "emptyName";
  ValidationOutputCustomerApiErrors[ValidationOutputCustomerApiErrors["emptyValue"] = 1] = "emptyValue";
  ValidationOutputCustomerApiErrors[ValidationOutputCustomerApiErrors["invalidType"] = 2] = "invalidType";
})(ValidationOutputCustomerApiErrors || (ValidationOutputCustomerApiErrors = {}));

var ValidationBodyCustomerApiErrors;

(function (ValidationBodyCustomerApiErrors) {
  ValidationBodyCustomerApiErrors[ValidationBodyCustomerApiErrors["invalidJson"] = 0] = "invalidJson";
})(ValidationBodyCustomerApiErrors || (ValidationBodyCustomerApiErrors = {}));

const validationInputsCustomerApi = inputs => {
  return inputs.map(input => {
    if (genericUtils.isEmpty(input.name)) {
      return ValidationInputCustomerApiErrors.emptyName;
    }

    if (genericUtils.isEmpty(input.value)) {
      return ValidationInputCustomerApiErrors.emptyValue;
    }

    return null;
  }).filter(value => value !== null);
};

const validationHeadersCustomerApi = headers => headers.map(header => {
  if (genericUtils.isEmpty(header.name)) {
    return ValidationHeaderCustomerApiErrors.emptyName;
  }

  if (genericUtils.isEmpty(header.value)) {
    return ValidationHeaderCustomerApiErrors.emptyValue;
  }

  return null;
}).filter(value => value !== null);

const validationOutputsCustomerApi = outputs => {
  return outputs.map(output => {
    if (genericUtils.isEmpty(output.name)) {
      return ValidationOutputCustomerApiErrors.emptyName;
    }

    if (genericUtils.isEmpty(output.value)) {
      return ValidationOutputCustomerApiErrors.emptyValue;
    }

    if (!['string', 'number', 'boolean'].includes(output.type)) {
      return ValidationOutputCustomerApiErrors.invalidType;
    }

    return null;
  }).filter(value => value !== null);
};

const validationBodysCustomerApi = body => {
  if (genericUtils.isJson(body) === false) {
    return ValidationBodyCustomerApiErrors.invalidJson;
  } // const bodyJson = JSON.parse(body) as Record<string, unknown>

};

const getManyCustomerApi = (getOneBotByBotId, getManyCustomerApiByBot) => async botId => {
  const bot = await getOneBotByBotId(botId);

  if (bot === null) {
    return GetManyCustomerApiErrors.inexistingBot;
  }

  const manyCustomerApi = getManyCustomerApiByBot(botId);
  return manyCustomerApi;
};

const getOneCustomerApiInfo = getOneCustomerApiInfoByIdAndBotId => async (botId, customerApiId) => {
  const customerApiInfo = await getOneCustomerApiInfoByIdAndBotId(botId, customerApiId);

  if (customerApiInfo === null) {
    return GetOneCustomerApiInfoErrors.inexistingCustomerApiInfo;
  }

  return customerApiInfo;
};

const createOneCustomerApiInfo = (getOneBotByBotId, customerApiInfoFactory, saveOneCustomerApi) => async (botId, customerApiData) => {
  if (genericUtils.isEmpty(customerApiData.url)) {
    return CreateOneCustomerApiInfoErrors.emptyUrl;
  }

  if (!genericUtils.isWebsiteUrlValid(customerApiData.url)) {
    return CreateOneCustomerApiInfoErrors.invalidUrlFormat;
  }

  if (genericUtils.isEmpty(customerApiData.name)) {
    return CreateOneCustomerApiInfoErrors.emptyName;
  }

  const resultsInputs = validationInputsCustomerApi(customerApiData.inputs);

  if (!genericUtils.isEmpty(resultsInputs.filter(resultInput => genericUtils.isDomainError(resultInput, ValidationInputCustomerApiErrors)))) {
    return CreateOneCustomerApiInfoErrors.inputsInvalid;
  }

  const resultsHeaders = validationHeadersCustomerApi(customerApiData.headers);

  if (!genericUtils.isEmpty(resultsHeaders.filter(resultHeader => genericUtils.isDomainError(resultHeader, ValidationHeaderCustomerApiErrors)))) {
    return CreateOneCustomerApiInfoErrors.headersInvalid;
  }

  const resultsOutputs = validationOutputsCustomerApi(customerApiData.outputs);

  if (!genericUtils.isEmpty(resultsOutputs.filter(resultOutput => genericUtils.isDomainError(resultOutput, ValidationOutputCustomerApiErrors)))) {
    return CreateOneCustomerApiInfoErrors.outputsInvalid;
  }

  if (customerApiData.method === 'POST') {
    const resultBody = validationBodysCustomerApi(customerApiData.body);

    if (genericUtils.isDomainError(resultBody, ValidationBodyCustomerApiErrors)) {
      return CreateOneCustomerApiInfoErrors.bodyInvalid;
    }
  }

  const bot = await getOneBotByBotId(botId);

  if (bot === null) {
    return CreateOneCustomerApiInfoErrors.inexistingBot;
  }

  const customerApiInfo = customerApiInfoFactory(botId, customerApiData);
  await saveOneCustomerApi(customerApiInfo);
  return customerApiInfo.id;
};

const updateOneCustomerApiInfo = (getOneCustomerApiInfoByIdAndBotId, updateOneCustomerApi) => async (botId, customerApiId, customerApiData) => {
  const customerApiInfo = await getOneCustomerApiInfoByIdAndBotId(botId, customerApiId);

  if (customerApiInfo === null) {
    return UpdateOneCustomerApiInfoErrors.inexistingCustomerApi;
  }

  if (genericUtils.isEmpty(customerApiData.url)) {
    return UpdateOneCustomerApiInfoErrors.emptyUrl;
  }

  if (!genericUtils.isWebsiteUrlValid(customerApiData.url)) {
    return UpdateOneCustomerApiInfoErrors.invalidUrlFormat;
  }

  if (genericUtils.isEmpty(customerApiData.name)) {
    return UpdateOneCustomerApiInfoErrors.emptyName;
  }

  const resultsInputs = validationInputsCustomerApi(customerApiData.inputs);

  if (!genericUtils.isEmpty(resultsInputs.filter(resultInput => genericUtils.isDomainError(resultInput, ValidationInputCustomerApiErrors)))) {
    return UpdateOneCustomerApiInfoErrors.inputsInvalid;
  }

  const resultsHeaders = validationHeadersCustomerApi(customerApiData.headers);

  if (!genericUtils.isEmpty(resultsHeaders.filter(resultHeader => genericUtils.isDomainError(resultHeader, ValidationHeaderCustomerApiErrors)))) {
    return UpdateOneCustomerApiInfoErrors.headersInvalid;
  }

  const resultsOutputs = validationOutputsCustomerApi(customerApiData.outputs);

  if (!genericUtils.isEmpty(resultsOutputs.filter(resultOutput => genericUtils.isDomainError(resultOutput, ValidationOutputCustomerApiErrors)))) {
    return UpdateOneCustomerApiInfoErrors.outputsInvalid;
  }

  if (customerApiData.method === 'POST') {
    const resultBody = validationBodysCustomerApi(customerApiData.body);

    if (genericUtils.isDomainError(resultBody, ValidationBodyCustomerApiErrors)) {
      return UpdateOneCustomerApiInfoErrors.bodyInvalid;
    }
  }

  await updateOneCustomerApi(botId, customerApiId, customerApiData);
};

const testCustomerApi = (getOneCustomerApiInfoByIdAndBotId, executeCustomerApi) => async (botId, customerApiId) => {
  const customerApiInfo = await getOneCustomerApiInfoByIdAndBotId(botId, customerApiId);

  if (customerApiInfo === null) {
    return TestCustomerApiErrors.inexistingCustomerApi;
  }

  const result = await executeCustomerApi(customerApiInfo.details);
  return result;
};

export { applicationPorts as appPorts, index$3 as botsRepositoryMongoDb, createOneCustomerApiInfo, index$4 as customerApiAxios, index as customerApiModel, index$2 as customersApiRepositoryAxios, index$1 as customersApiRepositoryPosgresql, entitiesSchemas$1 as entitiesSchemas, getManyCustomerApi, getOneCustomerApiInfo, testCustomerApi, updateOneCustomerApiInfo };
